module.exports = __webpack_public_path__ + "img/ru.7d85333c.png";